import React from 'react';
import { Route } from "react-router-dom";
import  RequestsHistoryListing from './requests_history.list';
import store from './filterStore';

const RequestsHistoryRouter = ({ match,location }) => (
  <div>
    <Route
      exact
      path={match.path}
      render={() => <RequestsHistoryListing store={store} />}
    />
  </div>
);

export default RequestsHistoryRouter;
